<template>
  <v-dialog v-model="shown" persistent width="350px" scrollable>
    <v-card>
      <v-card-title class="headline">{{ $t('tagger.title') }}</v-card-title>
      <v-divider />
      <v-card-text style="height: 400px" class="tagger">
        <v-layout row wrap align-center>
          <v-flex xs7>
            <v-text-field
              v-model="name"
              :placeholder="$t('tagger.addTag')"
            />
          </v-flex>
          <v-flex class="text-xs-right">
            <v-btn :loading="isBusy" @click.stop="add"><v-icon>add</v-icon>{{ $t('tagger.add') }}</v-btn>
          </v-flex>
        </v-layout>

        <v-checkbox
          v-for="(tag, i) in items"
          :key="tag.tagName"
          :label="tag.tagName"
          :value="i"
          v-model="indexes"
          hide-details
          class="my-0 py-0"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="red--text darken-1" flat="flat" @click.native="shown = false">Zrušit</v-btn>
        <v-btn class="green--text darken-1" flat="flat" @click.native="save">Uložit</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Tag from '@/models/Tag'

export default {
  props: {
    record: Object
  },
  created () {
    Tag.getList()
      .then(result => {
        this.items = result.items
      })
  },
  data () {
    return {
      shown: false,
      items: [],
      indexes: [],
      name: '',
      isBusy: false
    }
  },
  watch: {
    record () {
      this.indexes = this.record.tags.map(selected => {
        return this.items.findIndex(item => item._self === selected._self)
      })
    }
  },
  methods: {
    show () {
      this.name = ''
      this.shown = true
    },
    save () {
      this.$emit('save', this.indexes.map(index => this.items[index]), this.record)
      this.shown = false
    },
    add () {
      if (this.name.length > 0) {
        this.isBusy = true

        Tag.create({
          tagName: this.name
        })
        .then(result => {
          this.items.push(result)
          this.indexes.push(this.items.length - 1)
          this.name = ''
          this.isBusy = false
        })
        .catch(error => {
          console.error(error)
          alert(this.$t('savingFailed'))
          this.isBusy = false
        })
      }
    }
  }
}
</script>

<style>
.tagger .input-group__details {
  min-height: auto !important;
}
</style>



// WEBPACK FOOTER //
// Tagger.vue?0bcfb755